import './supervisor-view.component.ajscss';

import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './supervisor-view.component.ajs.html';

const MODULE_NAME = 'contactSupervisorView';

class SupervisorViewControler implements IComponentController {
  public name = MODULE_NAME;
  public UserTrackingFunction = UserTrackingFunction;
  $onInit() {}
}

export class SupervisorView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = [SupervisorViewControler];
}

export default MODULE_NAME;
